import PropTypes from 'prop-types';
import chunk from 'lodash/chunk';
import cn from 'classnames';
import get from 'lodash/get';
import size from 'lodash/size';
import pickBy from 'lodash/pickBy';
import identity from 'lodash/identity';
import React, {PureComponent} from 'react';
import css from './css.css';

import StyledCol from "~/components/TargetGrid/StyledCol";
import { Heading, Grid, Row, Col } from '~/native-ui';

export default class TargetRow extends PureComponent {
    static propTypes = {
        elements: PropTypes.arrayOf(PropTypes.shape({
            element: PropTypes.node.isRequired,
        })),
        xs: PropTypes.number.isRequired,
        md: PropTypes.number,
        lg: PropTypes.number,
        sm: PropTypes.number,
        gridWidth: PropTypes.number.isRequired,
        colStyles: PropTypes.object,

        captions: PropTypes.object,

        elementColClassName: PropTypes.string,
        rowClassName: PropTypes.string,
        captionRowClassName: PropTypes.string
    };

    static defaultProps = {
        xs: 4,
        gridWidth: 12,
        captions: null,
        elements: [],
        keyPrefix: '',
    };

    computeColSize = (num) => {
        if(!num) { return undefined; }

        if(this.props.gridWidth % num) {
            throw new Error('invalid this.props.fieldsPerRow '+this.props.xs);
        }

        return this.props.gridWidth / num;
    };

    computeColSizes = () => {
        return pickBy({
            xs: this.computeColSize(this.props.xs),
            md: this.computeColSize(this.props.md),
            lg: this.computeColSize(this.props.lg),
            sm: this.computeColSize(this.props.sm),
        }, identity);
    };

    renderEmptyColumn = ({ colSizes, index }) => {
        return (
            <StyledCol
                {...colSizes}
                {...this.props.columnStyle}
                key={"empty-cell" + index}
                className={this.props.elementColClassName}
            >
            </StyledCol>
        )
    }

    renderRows = () => {
        let colSizes = this.computeColSizes(),
            maxCols = [this.props.xs, this.props.md, this.props.lg, this.props.sm]
                .reduce((max, current) => current > max ? current : max, 0);

        let level = get(this.props.columnStyle, 'level');

        // console.log('colSizes', colSizes)

        let groupCaptionsRendered = {};

        let getCols = (elements) => {
            let captionCols = [];
            let elementCols  = [];
            let totalCols = 0;

            for(let i = 0; i < maxCols; i++) {
                if(i >= (elements.length)) {
                    continue;
                }

                let elementData = elements[i];

                if(this.props.captions) {
                    if(groupCaptionsRendered[elementData.group]) {
                        captionCols.push(<Col {...colSizes} key={`col-spacer-${i}-${elementData.name}`} />);
                    } else {
                        captionCols.push(<Col {...colSizes} key={`col-caption-${i}-${elementData.name}`} >
                            <Heading size="sm">{this.props.captions[elementData.group]}</Heading>
                        </Col>);

                        groupCaptionsRendered[elementData.group] = true;
                    }
                }

                elementCols.push(
                    <StyledCol
                        {...colSizes}
                        {...this.props.columnStyle}
                        key={i}
                        className={this.props.elementColClassName}
                    >
                        {elementData.element}
                    </StyledCol>
                );
            }

            return { captionCols, fieldCols: elementCols };
        };

        let allRows = chunk(this.props.elements, maxCols),
            rows = [];

        for(let i = 0; i < allRows.length; i++) {
            let { captionCols, fieldCols } = getCols(allRows[i]),
                blankCells = new Array(maxCols - fieldCols.length).fill(null).map((x, index) => this.renderEmptyColumn({ colSizes, index }));
            
            if(size(this.props.captions)) {
                rows.push((<Row key={`${this.props.keyPrefix}-row-caption-${i}`} className={cn(this.props.captionRowClassName)}>
                    {captionCols}
                    {blankCells}
                </Row>))
            }

            rows.push(
                <Row key={`${this.props.keyPrefix}-row-${i}`} className={cn(this.props.rowClassName)}>
                    {fieldCols}
                    {blankCells}
                </Row>
            )
        }

        return rows;
    };

    render() {
        return (
            <Row level={this.props.level}>
                <Grid className={cn(this.props.className, css.targetGrid)}>
                    {this.renderRows(this.props)}
                </Grid>
            </Row>
        );
    }
}